export const data = {
	heading: 'Credit.Club — команда с долгой историей',
}
